import sportsApi from '../../utils/sportsApi';
import { Campaign } from '@app/types/api';
import { AuthenticatedAccountPostsParams } from '@app/allSocialMediaPosts/api/getAllPosts';

export const getPostCampaigns = async (
    clientId: number,
): Promise<Campaign[]> => {
    const campaigns: any = await sportsApi
        .url(`/clients/${clientId}/social-campaigns`)
        .get()
        .json();
    return campaigns;
};

export const assignPostsToCampaignsFromQuery = async (
    clientId: number,
    queryParams: AuthenticatedAccountPostsParams,
    campaignId: number,
    excludedIds: number[] = [],
) => {
    // request uses same payload used to get posts
    const payload = {
        action: 'add',
        domainObject: {
            ...queryParams.domainObject,
            excludedIds,
        },
    };
    return sportsApi
        .url(`/clients/${clientId}/social-campaigns/${campaignId}/posts`)
        .json(payload)
        .post();
};

export const assignPostsToCampaign = async (
    clientId: number,
    campaignId: number,
    posts: any[],
) => {
    const payload = {
        action: 'add',
        domainObject: {
            postIds: posts,
        },
    };
    return sportsApi
        .url(`/clients/${clientId}/social-campaigns/${campaignId}/posts`)
        .json(payload)
        .post();
};

export const createCampaign = async (
    clientId: number,
    newCampaignName: string,
): Promise<{
    id: number;
    name: string;
    postCount: number;
    postEngagementTotal: number;
    postImpressionsTotal: number;
    postVideoViewsTotal: number;
    postFMVTotal: number;
    postEngagementAvg: number;
    postImpressionsAvg: number;
    postVideoViewsAvg: number;
    postFMVAvg;
}> => {
    const payload = {
        domainObject: {
            name: newCampaignName,
        },
        action: 'create',
    };

    return sportsApi
        .url(`/clients/${clientId}/social-campaigns`)
        .json(payload)
        .post()
        .json();
};

export const removePostFromCampaign = async (
    clientId: number,
    postId: number,
    campaignId: number,
) => {
    const payload = {
        action: 'remove',
        domainObject: {
            postIds: [postId],
        },
    };

    return sportsApi
        .url(`/clients/${clientId}/social-campaigns/${campaignId}/posts`)
        .json(payload)
        .post();
};
